export enum ShiftCodeTypeEnum {
  Operative = 1,
  Standby = 2,
  Vacation = 3,
  TimeOff = 4,
  Leave = 5,
  Administrative = 6,
  Complex = 7
}
